<!--
Page using MSAD info post-login. (Uses the msal plugin)

@author cm359n
-->
<template>
    <div id="contain" class="container">
        <div class='errorMsg' v-if="errorOccurred">
          {{ errorMsg }}
        </div>
        <div>
            <div v-if="username">
              Hello {{ userfullname }} ({{ username }})
            </div>
            <div v-else class="infoField">
                Please login.
                <button @click=testRedirect()>Click here to login</button>
            </div>
        </div>
    </div>
  </template>
  
  <script setup>
  import axios from 'axios'
  import { onMounted, ref } from 'vue'
  import { msalMethods } from '@/composables/MSALCommon.js'

  const { getAccount, getToken } = msalMethods()

  const errorOccurred = ref(false)
  const errorMsg = ref('')
  const username = ref('')
  const userfullname = ref('')
  onMounted(async () => {
 
    // works :-)
    // const account = await getAccount()
    // console.log(account)
    const account = await getAccount()
    const token = await getToken(account)
    // console.log(token) // BEWARE! DO NOT STORE TOKENS IN CLIENT SIDE!
    // get user data
    // ..... doesn't seem to have GUID
    // axios.get('https://graph.microsoft.com/v1.0/me',
    getInfoFromMSGraph(token)
    doUofgLifeCall(token)
  }) // end onMounted


  function doUofgLifeCall(token) {
    axios.post('/timetable/login/azure', {},
    {
        withCredentials: true,
        headers: { Authorization: 'Bearer ' + token }
      })
    .then(response => {
      console.log(response.data)
    })
  }

  function getInfoFromMSGraph(token) {
    axios.get('https://graph.microsoft.com/v1.0/me?$select=givenName,surname,mailnickname',
    {
        withCredentials: false,
        headers: { Authorization: 'Bearer ' + token }
      })
    .then(response => {
      if (response.data) {
        const msdata = response.data
        userfullname.value = msdata.givenName + ' ' + msdata.surname
        username.value = msdata.mailNickname
      }
    })
    .catch(error => {
      console.log(error)
    })

  }

  </script>
  
  <style>
  .infoField {
    background-color:#ffffff;
    color:#003865;
    font-weight:700;
    border-left:0px;
    border-bottom:1px solid #e4e4e4;
    border-right:0px;
    line-height:48px;
    margin-left:24px;
    margin-right:24px;
    height:48px;
    font-family:PTSans;
  }
  </style>
  